<template>
  <div id="app">
    <!--仿造一个小型的商城，此处区域分成三个，header,内容部分，底部选择框-->
    <mt-header fixed :title="this.title">
      <a @click="routeBack" slot="left" v-show="returnFlag">
        <mt-button icon="back" v-show="$route.name !== 'Login'"></mt-button>
      </a>
    </mt-header>
    <transition>
      <router-view @getTitle="getTitleFromSon" />
    </transition>
    <!--    底部选择框-->
    <div
      id="tabbar"
      v-show="$route.meta.navShow == undefined || $route.meta.navShow"
    >
      <nav
        class="mui-bar mui-bar-tab"
        v-show="
          $route.name !== 'Login' &&
          $route.name !== 'smslogin' &&
          $route.name !== 'register'
        "
      >
        <router-link class="mui-tab-item-home" to="/home">
          <span class="mui-icon mui-icon-home"></span>
          <span class="mui-tab-label mui-active">任务大厅</span>
        </router-link>
        <router-link class="mui-tab-item-home" to="/hall">
          <span class="mui-icon mui-icon-plus"></span>
          <span class="mui-tab-label">数据采集</span>
        </router-link>
        <router-link class="mui-tab-item-home" to="/user">
          <span class="mui-icon mui-icon-contact"></span>
          <span class="mui-tab-label">我的</span>
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import Vue from "vue";
// import md5 from '_js-md5@0.7.3@js-md5'
import md5 from "js-md5";
export default {
  name: "App",
  data() {
    return {
      returnFlag: 0,
      title: "无障碍设施采集系统",
    };
  },
  created() {
    if (process.env.isgetwxcode) {
      this.isGetCode();
    } else {
      window.localStorage.setItem("userOpenid", "oUILq1WPPapGyS2Yi8phWfwZld34"); //测试时候默认openid
      window.localStorage.setItem("uid", 16);
    }

    this.returnFlag = this.$route.path === "/" ? 0 : 1;
  },
  methods: {
    routeBack() {
      this.$router.back();
    },
    getTitleFromSon(title) {
      this.title = title;
    },
    getUserOpenId() {
      let openid = window.localStorage.getItem("userOpenid");
      if (
        openid !== "undefined" &&
        openid !== "null" &&
        openid !== "" &&
        openid
      ) {
        return openid;
      } else {
        let openid = this.$route.query["openid"];
        if (openid) {
          return openid;
        } else {
          return false;
        }
      }
    },
    isWeiXin() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") > -1) {
        return true;
      } else {
        return false;
      }
    },
    isUid() {
      let uid = window.localStorage.getItem("uid");
      if (uid !== "undefined" && uid !== "null" && uid !== "" && uid) {
        return uid;
      } else {
        let uid = this.$route.query["uid"];
        if (uid) {
          return uid;
        } else {
          return false;
        }
      }
    },
    isGetCode() {
      if (!(this.getUserOpenId() && this.isUid())) {
        if (this.isWeiXin()) {
          if (this.$route.name === "Login" && this.getUserOpenId()) {
            window.localStorage.setItem("userOpenid", this.getUserOpenId());
            let time = new Date().toLocaleString();
            let openid = this.getUserOpenId();
            let salt = "onbotics";
            Vue.http.headers.common["openid"] = encodeURIComponent(openid);
            Vue.http.headers.common["time"] = encodeURIComponent(time);
            Vue.http.headers.common["token"] = encodeURIComponent(
              md5(openid + salt + time + salt)
            );
          } else {
            let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx74825b32a834bacd&redirect_uri=https%3A%2F%2Fpgather.onbotics.cn%2Fapi%2Fgather%2Fgetopenid&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
            console.log(url);
            window.location.href = url;
          }
        } else {
          Toast("请使用微信浏览器打开该页面");
        }
      } else if (this.getUserOpenId()) {
        window.localStorage.setItem("userOpenid", this.getUserOpenId());
        let time = new Date().toLocaleString();
        let openid = this.getUserOpenId();
        let salt = "onbotics";
        Vue.http.headers.common["openid"] = encodeURIComponent(openid);
        Vue.http.headers.common["time"] = encodeURIComponent(time);
        Vue.http.headers.common["token"] = encodeURIComponent(
          md5(openid + salt + time + salt)
        );
      }
      if (this.isUid()) {
        window.localStorage.setItem("uid", this.isUid());
      }
    },
  },
  watch: {
    $route: function () {
      if (this.$route.path !== "/") {
        this.returnFlag = 1;
      }
    },
  },
};
document.write(
  '<script src="/static/config.js?v=' + Math.random() + '">\x3c/script>'
);
</script>

<style>
#app {
  padding-top: 40px;
  overflow-x: hidden;
}

* {
  touch-action: pan-y;
}

.v-enter {
  opacity: 0;
  transform: translateX(100%);
}
textarea,
input {
  font-size: 16px !important;
}
.v-level-to {
  opacity: 0;
  transform: translateX(-100%);
  position: absolute;
}

.v-enter-active,
.v-level-active {
  transition: all 0.5s ease;
}

.mui-bar-tab .mui-tab-item-home.mui-active {
  color: #007aff;
}
.mui-bar-tab .mui-tab-item-home {
  display: table-cell;
  overflow: hidden;
  width: 1%;
  height: 50px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #929292;
}
.mui-bar-tab .mui-tab-item-home .mui-icon {
  top: 3px;
  width: 24px;
  height: 24px;
  padding-top: 0;
  padding-bottom: 0;
}
.mui-bar-tab .mui-tab-item-home .mui-icon ~ .mui-tab-label {
  font-size: 11px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* .hallContainer{
    height: 100vh!important;
  } */
.fade {
  width: 100vw;
  height: calc(100vh - 100px);
  position: fixed;
  /* background: red; */
  /* background: none; */
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue